import { Pencil } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { fmtDate } from "@/lib/format";

export function ProgressPicker({ recs, onPick, onClose }) {
  return (
    <Dialog open={!!recs} onOpenChange={(o) => { if (!o) { onClose(); } }}>
      <DialogContent className="max-w-md" data-testid="progress-picker">
        <DialogHeader><DialogTitle>Which progress report?</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-500">{recs?.[0]?.church_name} has {recs?.length} reports in this period. Pick one to edit.</p>
        <div className="max-h-80 space-y-2 overflow-y-auto">
          {(recs || []).map((r) => (
            <button key={r.id} type="button" onClick={() => onPick(r)} className="flex w-full items-center justify-between rounded-lg border border-slate-200 px-4 py-3 text-left transition-colors hover:bg-slate-50" data-testid={`progress-pick-${r.id}`}>
              <span className="font-semibold">{fmtDate(r.date)}</span>
              <span className="flex items-center gap-2 text-sm text-slate-500">Ri-Jar {r.ri_jar ?? 0} · Members {r.active_members ?? 0} <Pencil className="h-4 w-4" /></span>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
